import { useSession } from 'components/Auth/useSession'

export const Session = () => {
  useSession()
  return null
}
